import React, {useContext, useEffect} from 'react';
import {useNavigation} from '@react-navigation/native';

import AuthContext from '../context/AuthContext';

const withProtectedScreen = (StackScreen) => {
  return (props) => {
    const {authenticated} = useContext(AuthContext);
    const navigation = useNavigation();

    useEffect(() => {
      if (!authenticated) {
        navigation.navigate(
          'SignIn',
          StackScreen.screen
            ? {
                redirect: {
                  screen: StackScreen.screen,
                  params: props.route.params,
                },
              }
            : undefined,
        );
      }
    }, [StackScreen, authenticated, navigation, props.route.params]);

    return authenticated ? <StackScreen {...props} /> : null;
  };
};

export default withProtectedScreen;
